import {
  SET_INVITATION,
  CLOSE_INVITATION,
  CHECK_INVITATION_STATUS,
  SET_INVITATION_DATA,
} from "../types/confirmInvitationTypes";

const initialState = {
  openConfirm: false,
  registerData: {},
  enterpriseID: "",
  status: {},
};

const confirmInvitationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INVITATION:
      return { ...state, openConfirm: true, enterpriseID: action.payload };
    case SET_INVITATION_DATA:
      return { ...state, registerData: action.payload };
    case CLOSE_INVITATION:
      return { ...state, openConfirm: false, enterpriseID: "" };
    case CHECK_INVITATION_STATUS:
      return { ...state, status: action.payload };
    default:
      return state;
  }
};

export default confirmInvitationReducer;
